export const ROUTES = {
  home: '/',
  login: '/login',
  register: '/register',
  forgotPassword: '/forgot-password',
  dashboard: '/dashboard',
  transactions: '/transactions',
  wallet: '/wallet',
  walletTransfer: '/wallet/transfer',
  profile: '/profile',
  profileEdit: '/profile/edit',
  kycHome: '/kyc',
  kycUpload: '/kyc/upload',
  kycStatus: '/kyc/status',
  adminKyc: '/admin/kyc',
  adminOperations: '/admin/operations',
  adminUsers: '/admin/users',
  adminAudit: '/admin/audit',
  notifications: '/notifications',
  notificationSettings: '/settings/notifications',
  adminNotifications: '/admin/notifications',
  adminNotificationTemplates: '/admin/notification-templates',
} as const;
